import React from 'react';
import { Button } from '../ui/button';

export interface CompanyNoPlanContactAdminProps {
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const CompanyNoPlanContactAdmin: React.FC<CompanyNoPlanContactAdminProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
}) => (
  <div className="flex flex-col items-center min-h-screen text-center mt-9 text-neutral-40">
    <div className="max-w-[744px] w-full flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center w-full">
        <h2 className="mt-8 text-2xl font-bold leading-8 text-neutral-10">
          {title}
        </h2>
      </div>
      <p className="mt-8 mb-5">{description}</p>
      {buttonText && onButtonClick && (
        <Button
          className="gap-2 min-w-[258px] mt-4"
          onClick={onButtonClick}
          aria-label={buttonText}
        >
          {buttonText}
        </Button>
      )}
    </div>
  </div>
);

export default CompanyNoPlanContactAdmin;
